export default function uploadNotice(skippedDuplicates = []) {
  if (skippedDuplicates.length === 0) {
    return {
      title: 'Success',
      text: 'Document(s) have been uploaded.',
      type: 'success',
    };
  }

  const single = skippedDuplicates.length === 1;

  return {
    title: 'Already uploaded',
    text: `${skippedDuplicates.join(', ')} ${single ? 'already exists' : 'already exist'} and ${single ? "wasn't" : "weren't"} added.`,
    type: 'warn',
  };
}
